import Script from 'next/script';

import type { FrontifyImageContent } from '@/contentful';
import { setImgWidth } from '@/utils/frontify';

interface Props {
  path: string;
  headline: string;
  description: string;
  image?: FrontifyImageContent;
  datePublished: string | Date;
  lastUpdated?: string;
  dateModified: Date;
}

export default function ArticleSchema(props: Props) {
  const {
    path,
    headline,
    description,
    image,
    dateModified,
    datePublished,
    lastUpdated,
  } = props;

  const formattedDateModified = dateModified.toISOString();
  const formattedDatePublished =
    typeof datePublished === 'string'
      ? `${datePublished}T13:00:00.000Z`
      : datePublished.toISOString();
  const formattedLastUpdated =
    lastUpdated && typeof lastUpdated === 'string'
      ? `${lastUpdated}T13:00:00.000Z`
      : lastUpdated?.toString();

  // Use lastUpdated for schema if present, otherwise use published date
  const schemaDatePublished = formattedLastUpdated || formattedDatePublished;
  const schemaDateModified = formattedLastUpdated || formattedDateModified;

  return (
    <Script type='application/ld+json' strategy='beforeInteractive'>
      {`{
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://sunrun.com${path}"
        },
        "headline": "${headline}",
        "description": "${description}",
        "image": "${setImgWidth(image?.preview_url, 1920)}",
        "author": {
          "@type": "Person",
          "name": "Sunrun Experts"
        },
        "datePublished": "${schemaDatePublished}",
        "dateModified": "${schemaDateModified}"
      }`}
    </Script>
  );
}
